<template>
  <v-navigation-drawer v-model="drawer" class="elevation-4"
  app floating
  width="320px"
  >
    <v-row
      class="fill-height flex-nowrap" 
      no-gutters
    >
      <v-navigation-drawer v-model="drawer" class="fill-height" height="100%" disable-resize-watcher mobile-breakpoint="0" touchless color="teal darken-4"
        style="background: linear-gradient(180deg, rgb(0,77,64), rgb(4, 58, 49)) !important"
        dark floating
        mini-variant-width="56"
        :mini-variant="mini"
      >
        <v-list-item class="px-2 pt-2">
          <v-list-item-avatar @click="$router.push({name:'Profile'})">
            <v-img  :src="!!user.avatar? user.avatar.includes('http')?user.avatar: $baseURL +user.avatar : '/static/icons/avatar_holder.png'"></v-img>
          </v-list-item-avatar>
          <v-list-item-content>
            Xin chào {{user.employeeName}} 
          </v-list-item-content>
          <v-list-item-action>
            <!-- <v-icon @click="mini=true">mdi-arrow-left </v-icon> -->
          </v-list-item-action>
        </v-list-item>
        <v-btn color="transparent" width="100%" depressed style="height: 20px;" @click="mini = !mini"><v-icon left>mdi-dots-horizontal</v-icon></v-btn>

        <v-divider class="mt-4"></v-divider>

        <v-list nav
          dense class="rounded-xl" dark
        >
          <v-list-item-group
            v-model="selectedItem"
            color="light-green"
          >
            <v-tooltip right v-for="section in validSections" :key="section.title" :disabled="!mini" open-delay="0" color="#125C34" content-class="clean-tooltip">
              <template v-slot:activator="{ on, attrs }">
                <v-list-item link
                  :to="section.href"
                  class="mb-2 rounded-lg mini-section-item"
                  active-class="mini-active"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-list-item-action>
                    <v-icon size="24" :color="section.color" class="mx-auto section-icon">{{ section.icon }}</v-icon>
                  </v-list-item-action>

                  <v-list-item-content>
                    <v-list-item-title>{{ $t(section.title) }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <span class="font-weight-bold tooltip-text">{{ $t(section.title) }}</span>
            </v-tooltip>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>

      <v-list :class="`grow ${mini? '': 'd-none'} `" width="calc(100% - 56px)" dense id="main_menu" style="height: 100vh; overflow-y: auto; overflow-x: hidden; padding-bottom: 60px; background-color: #f8f9fa;">
        
        <v-list-item class="px-2 mb-4 mt-2" >
          <img src='/static/logo2.png' alt="logo" height="48" class="mx-auto" @click="$router.push({name: 'Home'})" style="cursor:pointer; object-fit: contain;">
        </v-list-item>
        
          <div class="dynamic-list mt-1" v-for="(item, i) in items" :key="i" >
            <v-subheader v-if="item.subheader" class="font-weight-bold blue-grey--text text--darken-1 pl-6 mb-1 mt-4" style="text-transform: uppercase; font-size: 11px; letter-spacing: 0.12em; height: 32px; background-color: transparent;">
              {{ $t(item.title) }}
            </v-subheader>

            <v-list-item
              v-if="!item.subs && !item.subheader && authorize(item.auth) && (item.webAllowed || item.webAllowed==null)" 
              link :to="item.route"  
              class="text-decoration-none sidebar-item" active-class="modern-selected pl-4">
              <v-list-item-icon class="mr-4">
                <v-icon size="22" class="sidebar-icon"> {{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="font-weight-regular" style="font-size: 14px !important; color: #333;">
                    <v-badge inline class="my-auto"
                      color="error"
                      icon="mdi-lock"
                      :content="item.badge"
                      :value="!!item.badge"
                      v-if="!!item.badge"
                    >
                    {{ $t(item.title) }}
                    </v-badge>
                    <span v-else>{{ $t(item.title) }}</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-group v-if="item.subs && authorize(item.auth)" :group="item.group" no-action class="sidebar-group">
              <template v-slot:prependIcon>
                <v-icon size="22" class="sidebar-icon"> {{ item.icon }}</v-icon>
              </template>
              <template v-slot:activator>
                <v-list-item-content >
                  <v-list-item-title class="font-weight-regular" style="font-size: 14px !important; color: #333;"> {{ $t(item.title) }}</v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item active-class="modern-sub-selected"
                v-for="(child, i) in item.subs"
                :key="i"
                link :to="child.route"  class="text-decoration-none sidebar-item pl-8" v-if="authorize(child.auth) ">
                <v-list-item-content>
                  <v-list-item-title class="font-weight-regular" style="font-size: 13px !important; color: #444;">
                    <v-badge inline class="my-auto font-weight-light"
                      color="error"
                      icon="mdi-lock"
                      :content="child.badge"
                      :value="!!child.badge"
                      v-if="!!child.badge"
                    >
                    {{ $t(child.title) }}
                    </v-badge>
                    <span v-else>
                      <v-icon size="6" class="mr-2 sidebar-icon">mdi-circle</v-icon>
                      {{ $t(child.title) }}
                    </span>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </div>

      </v-list>
    </v-row>
  </v-navigation-drawer>
</template>

<script>
import axios from "axios";

export default {
name: "SideBar",
props: {
  value: { type: Boolean },
  items: { type: Array },
  validSections: { type: Array },
},

data() {
  return {
    claims: ["employee:index", "employee:create", "role:index"],
    drawer: false,
    // drawer1: true,
    mini:true,
    sectionColor: 'green'
  };
},
computed: {
  userClaims () {
    return localStorage.getItem("userClaim");
  },
  user () {
    let user = localStorage.getItem("user");
    user = JSON.parse(user);
    return user;
  },

  AuthorizeMenu () {
    if(!this.items)
    {
      return [];
    }
    var claims = this.userClaims;
    var result = this.items.map(obj => {
      if(obj.subs)
      {
        if(obj.authorize)
        {
          if(claims.includes(obj.authorize))
            return Object.assign({}, obj, {
              subs: obj.subs.filter(el => claims.includes(el.authorize))
            })
        }
        else {
          return Object.assign({}, obj, {
            subs: obj.subs.filter(el => claims.includes(el.authorize) || !el.authorize)
          })
        }
      }
      else {
        if(obj.authorize)
        {
          if(claims.includes(obj.authorize))
            return obj;
        } else return obj;
      }
    }).filter(u => u != undefined);
    return result;
  }
},
watch: {
  value: function () {
    this.localDrawer = this.value;
  },
  mini(value){
    console.log(value)
  }
},
methods:{

  authorize(value)
  {
    if(typeof value == 'object'){
      let result = true;
      value.forEach(x=> {
        result = result && this.userClaims.includes(x);
      })
      return result;
    }else{
      return this.userClaims.includes(value)
    }
  },
  openDrawer: function (val) {
    this.drawer = val;
    // this.$emit("input", this.localDrawer);
  },
},
mounted() {
  console.log("rendered");
  // console.log(this.userClaims);
  if (this.$vuetify.breakpoint.name === 'xs') {
    this.drawer = false
    this.mini = true
    console.log(this.mini)
  } else if (this.$vuetify.breakpoint.name === 'sm') {
    this.mini = true
    this.drawer=false
  } else if (this.$vuetify.breakpoint.name === 'md') {
    this.mini = true
    this.drawer=true
    // Do something when the viewport is in medium (md) breakpoint
  } else if (this.$vuetify.breakpoint.name === 'lg') {
    this.mini = true
    this.drawer=true
    // Do something when the viewport is in large (lg) breakpoint
  } else if (this.$vuetify.breakpoint.name === 'xl') {
    this.mini = true
    this.drawer=true
    // Do something when the viewport is in extra-large (xl) breakpoint
  }
},
created() {
  
}

};
</script>

<style scoped>
  .modern-selected {
    background-color: #125C34 !important; /* deep forest green */
    color: white !important;
    box-shadow: 0 4px 8px rgba(18, 92, 52, 0.25);
  }
  .modern-sub-selected {
    background-color: #E8F5E9 !important; /* light soft green */
    color: #125C34 !important;
  }
  .modern-sub-selected .v-list-item__title {
    color: #125C34 !important;
    font-weight: 600 !important;
  }

  ::v-deep .modern-selected .sidebar-icon,
  ::v-deep .modern-selected .v-list-item__title {
    color: white !important;
    font-weight: 500 !important;
  }
  
  .sidebar-icon {
    color: #597A66 !important; /* muted forest green */
  }

  .sidebar-item {
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    margin: 4px 12px !important;
    border-radius: 10px !important;
  }

  .sidebar-item::before {
    border-radius: 10px !important;
  }
  
  .sidebar-item:hover {
    background-color: #E8F5E9 !important;
    transform: translateX(4px);
  }
  
  .sidebar-item:hover .v-list-item__title,
  .sidebar-item:hover .sidebar-icon,
  .sidebar-item:hover .v-icon {
    color: #125C34 !important;
  }

  .v-list-group::v-deep .v-list-group__header {
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    margin: 4px 12px !important;
    border-radius: 10px !important;
  }

  .v-list-group::v-deep .v-list-group__header::before {
    border-radius: 10px !important;
  }

  .v-list-group::v-deep .v-list-group__header:hover {
    background-color: #E8F5E9 !important;
  }
  
  .v-list-group::v-deep .v-list-group__header:hover .v-list-item__title,
  .v-list-group::v-deep .v-list-group__header:hover .sidebar-icon,
  .v-list-group::v-deep .v-list-group__header:hover .v-icon {
    color: #125C34 !important;
  }

  .mini-section-item {
    transition: all 0.3s ease;
  }

  .mini-section-item .section-icon {
    color: rgba(255, 255, 255, 0.7) !important;
    transition: color 0.3s ease;
  }

  .mini-section-item:hover {
    background-color: rgba(255, 255, 255, 0.1) !important;
  }

  .mini-section-item:hover .section-icon {
    color: white !important;
  }

  .mini-active {
    background-color: #f8f9fa !important;
    position: relative;
  }

  .mini-active .section-icon {
    color: #004D40 !important; /* Forces active icon to match Teal Darken 4 so it shows cleanly against the white bg */
  }
  
  .mini-active::before {
    content: '';
    position: absolute;
    left: 0;
    top: 15%;
    height: 70%;
    width: 3px;
    background-color: #004D40;
    border-radius: 0 4px 4px 0;
  }

  ::v-deep .clean-tooltip {
    background-color: rgba(18, 92, 52, 0.95) !important; /* deep forest green */
    border: 1px solid #0f4d2c !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
    border-radius: 6px !important;
    padding: 6px 12px !important;
    pointer-events: none;
  }

  ::v-deep .clean-tooltip .tooltip-text {
    color: white !important;
    letter-spacing: 0.02em;
    font-size: 13px;
    font-weight: 500 !important;
  }

  /* .darken-selected {

    background-color: green;
    color: white !important;
  }
  ::v-deep .darken-selected .v-icon{
    color: white !important;
  } */
  ::v-deep .v-navigation-drawer__content {
    scrollbar-width: none;
  }
  #main_menu::-webkit-scrollbar {
    display: none;
  }
  #main_menu {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
  }
</style>
